import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressTestPageComponent } from './progress-test-page/progress-test-page.component';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { UserwaySyncModule } from '../shared/userway-sync.directive';
import { WindowService } from '../shared/window.service';
@NgModule({
  imports: [CommonModule, SafeUrlPipeModule, UserwaySyncModule],
  declarations: [ProgressTestPageComponent],
  providers: [WindowService]
})
export class ProgressTestModule { }



// WEBPACK FOOTER //
// ./ts/app/progress-test/progress-test.module.ts